// extracted by mini-css-extract-plugin
export default {"borrowed-books":"BorrowedBooks_borrowed-books__9OHVV"};